export const menuItems = [
    { title: "Add or View Exam" },
    { title: "Add or View Course" },
    { title: "Set Exam Questions" },
    { title: "View Attempt Logs" },
    { title: "View Student Attempts" }
];

export let mainNav = null
export const subNav = []